import { render, staticRenderFns } from "./pos.vue?vue&type=template&id=5caec5cd&scoped=true"
import script from "./pos.vue?vue&type=script&lang=js"
export * from "./pos.vue?vue&type=script&lang=js"
import style0 from "./pos.vue?vue&type=style&index=0&id=5caec5cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caec5cd",
  null
  
)

export default component.exports